import PropTypes from "prop-types";
import { isMobile } from "react-device-detect";

export const HeadersBuildSection = ({ headerLabel, headerLineImgSrc, subheaderLabel = null }) => {
  return (
    <div className="headers d-flex flex-column mb-4">
      <h5 className="text-center pt-3 mb-0">{headerLabel} </h5>
      {!isMobile && <img style={{ width: "100px" }} className="mt-1 mx-auto" alt="header underline" src={headerLineImgSrc} />}
      {subheaderLabel && (
        <h4 style={{ color: "#4A5E8F" }} className="text-center fw-bold mt-1 mb-0">
          {subheaderLabel}{" "}
        </h4>
      )}
    </div>
  );
};

HeadersBuildSection.propTypes = {
  headerLabel: PropTypes.string.isRequired,
  headerLineImgSrc: PropTypes.string,
  subheaderLabel: PropTypes.string,
};
